import { render, staticRenderFns } from "./User_Info.vue?vue&type=template&id=f20d111e&scoped=true&"
import script from "./User_Info.vue?vue&type=script&lang=js&"
export * from "./User_Info.vue?vue&type=script&lang=js&"
import style0 from "./User_Info.vue?vue&type=style&index=0&id=f20d111e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20d111e",
  null
  
)

export default component.exports